import React, { useState } from 'react';
import { User } from 'lucide-react';
import PhotoZoomModal from './PhotoZoomModal';

const ChildAvatar = ({ photo, name, size = 'md', className = '', zoomable = false }) => {
  const [isZoomed, setIsZoomed] = useState(false);

  const sizeClasses = {
    xs: 'w-6 h-6',
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const iconSizes = {
    xs: 'h-3 w-3',
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-6 w-6',
    xl: 'h-8 w-8'
  };

  const handleClick = (e) => {
    if (zoomable) {
      e.stopPropagation();
      setIsZoomed(true);
    }
  };

  return (
    <>
      <div 
        className={`${sizeClasses[size]} rounded-full overflow-hidden flex-shrink-0 ${className} ${zoomable ? 'cursor-pointer hover:ring-2 hover:ring-[#D87A4E] hover:ring-offset-2 transition-all' : ''}`}
        onClick={handleClick}
        title={zoomable ? 'Clique para ampliar a foto' : undefined}
      >
        {photo ? (
          <img 
            src={photo} 
            alt={name} 
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full bg-slate-200 flex items-center justify-center">
            <User className={`${iconSizes[size]} text-slate-400`} />
          </div>
        )}
      </div>

      {zoomable && (
        <PhotoZoomModal
          isOpen={isZoomed}
          onClose={() => setIsZoomed(false)}
          photo={photo}
          name={name}
        />
      )}
    </>
  );
};

export default ChildAvatar;
